var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVirtualTour(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 66,
    viewBox: "0 0 68 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#virtual-tour_svg__clip0_90_2236)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6F8FF",
    d: "M27.19 44.459h11.583v18.497H27.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.234 45.865v17.213h-3.089V42.776h15.817v20.302h-3.089V45.865h-9.639z",
    fill: "#506BCA"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40.876 43.365h4.512v5.632h-4.512z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.554 1.006l33.136 18.96-1.534 2.681L33.554 4.565 1.95 22.647l-1.534-2.68 33.137-18.96z",
    fill: "#506BCA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.355 61.533V15.677h-3.09v48.945h48.576V15.677h-3.089v45.856H12.355z",
    fill: "#506BCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.866 56.513a1.75 1.75 0 01-1.706 1.793l-11.382.283a1.75 1.75 0 01-1.793-1.706l-.06-2.4a1.75 1.75 0 011.706-1.794m13.235 3.824L3.631 52.689m13.235 3.824l-.06-2.401a1.75 1.75 0 00-1.793-1.706l-11.382.283m13.235 3.824L3.631 52.689m34.47-33.02l-1.157.474 1.157-.474-.91-2.223a1.75 1.75 0 00-2.283-.956l-1.983.812c-4.193 1.718-6.634 5.229-7.304 8.987-.18 1.01.544 1.893 1.487 2.018l2.381.313.156-1.184-.156 1.184c.977.129 1.794-.558 1.966-1.424.371-1.865 1.57-3.557 3.707-4.432l1.983-.812a1.75 1.75 0 00.956-2.283zm-10.952 9.743l.256 1.224-.256-1.224c-.93.194-1.586 1.13-1.331 2.123.948 3.698 3.645 7.016 7.955 8.415 2.696.876 3.998 2.887 4.232 5.06.094.88.85 1.636 1.834 1.592l2.4-.105c.95-.042 1.747-.859 1.657-1.88-.388-4.361-3.096-8.59-8.3-10.28-2.197-.713-3.52-2.31-4.028-4.143-.237-.85-1.103-1.474-2.068-1.273l-2.35.49zm-6.862 28.766l11.882-.296c5.47-.136 9.272-3.418 10.886-7.487.378-.953-.154-1.964-1.052-2.275l-2.27-.785c-.931-.322-1.871.187-2.213 1.003-.843 2.017-2.664 3.574-5.498 3.644l-11.882.296a1.75 1.75 0 00-1.706 1.793l.06 2.401a1.75 1.75 0 001.793 1.706z",
    fill: "#506BCA",
    stroke: "#fff",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.092 16.436l-1.244-.413.603-1.818m.641 2.231l-.64-2.231m.64 2.231l-1.244-.413a1.875 1.875 0 001.189 2.37m.055-1.957l-.055 1.957m-.586-4.188a1.875 1.875 0 012.37-1.19m-2.37 1.19l2.37-1.19m-.433 1.306l.433-1.305 8.529 2.83a1.875 1.875 0 011.121 2.545l-3.669 8.203a1.875 1.875 0 01-2.477.946l-1.749-.782a1.875 1.875 0 01-.946-2.477l1.958-4.378-4.551-1.51m1.351-4.072l-1.351 4.072m1.351-4.072l.433-1.305m-.433 1.305l.433-1.305",
    fill: "#506BCA",
    stroke: "#fff",
    strokeWidth: 2.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "virtual-tour_svg__clip0_90_2236"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.065 .5)",
    d: "M0 0h67v65H0z"
  })))));
}
export default __webpack_public_path__ + "media/service/virtual-tour-67128d40.svg";
export { SvgVirtualTour as ReactComponent };